/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */
import {useMutation} from 'react-query';
import {taskEmailExportLargeEntities} from '@ion/core/src/services/Connect';
import {TaskEmailExportOperation} from '@ion/core/src/types/entities';

export type UseTaskEmailExportOperationResult = {
  process: (params: TaskEmailExportOperation, callbacks) => void;
}

/**
 * Hook for calling the task email export operation api for bulk entity activities.
 *
 * ```typescript
 *
 *  import {useTaskEmailExportOperation} from '@ion/packages/query/src/hooks';
 *
 *  const {process} = useTaskEmailExportOperation({taskId, operation});
 *
 * ```
 */
export const useTaskEmailExportOperation = (): UseTaskEmailExportOperationResult => {
  const {mutate} = useMutation(async({
    taskId,
    timeZone,
    emailRecipients,
    exportColumns,
    customLogicFields,
    dateFormatFields
  }: TaskEmailExportOperation) => {
    return await taskEmailExportLargeEntities(taskId, {
      timeZone,
      emailRecipients,
      exportColumns,
      customLogicFields,
      dateFormatFields
    });
  });

  return {
    process : mutate
  };
};

export default useTaskEmailExportOperation;
